// Simple notification system to replace antd notification
let notificationContainer = null;

const DEFAULT_DURATIONS = {
  success: 4000,
  error: 8000,
  warning: 8000,
  info: 5000,
};

export const showNotification = (type, message, description = '', duration) => {
  const resolvedDuration = duration ?? DEFAULT_DURATIONS[type] ?? 5000;
  if (!notificationContainer) {
    notificationContainer = document.createElement('div');
    notificationContainer.id = 'notification-container';
    notificationContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      pointer-events: none;
    `;
    document.body.appendChild(notificationContainer);
  }

  const notification = document.createElement('div');
  const bgColor = type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : type === 'warning' ? '#f59e0b' : '#3b82f6';
  
  notification.style.cssText = `
    background: white;
    border-left: 4px solid ${bgColor};
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    min-width: 300px;
    max-width: 400px;
    pointer-events: auto;
    animation: slideIn 0.3s ease-out;
  `;

  notification.innerHTML = `
    <div style="display: flex; align-items: start; gap: 12px;">
      <div style="
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: ${bgColor};
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: white;
        font-weight: bold;
        font-size: 14px;
      ">
        ${type === 'success' ? '✓' : type === 'error' ? '✕' : type === 'warning' ? '⚠' : 'ℹ'}
      </div>
      <div style="flex: 1;">
        <div style="font-weight: 600; color: #1f2937; margin-bottom: 4px;">${message}</div>
        ${description ? `<div style="font-size: 14px; color: #6b7280;">${description}</div>` : ''}
      </div>
      <button onclick="this.parentElement.parentElement.remove()" style="
        background: none;
        border: none;
        cursor: pointer;
        color: #9ca3af;
        font-size: 18px;
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      ">×</button>
    </div>
  `;

  // Add animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
  if (!document.head.querySelector('#notification-styles')) {
    style.id = 'notification-styles';
    document.head.appendChild(style);
  }

  notificationContainer.appendChild(notification);

  // Auto remove after duration
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(() => {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 300);
  }, resolvedDuration);

  // Add slideOut animation
  if (!document.head.querySelector('#notification-slideout')) {
    const slideOutStyle = document.createElement('style');
    slideOutStyle.id = 'notification-slideout';
    slideOutStyle.textContent = `
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(slideOutStyle);
  }
};

export const message = {
  success: (content, duration) => showNotification('success', content, '', duration),
  error: (content, duration) => showNotification('error', content, '', duration),
  warning: (content, duration) => showNotification('warning', content, '', duration),
  info: (content, duration) => showNotification('info', content, '', duration),
};

export const notification = {
  success: (options) => showNotification('success', options.message || '', options.description || '', options.duration),
  error: (options) => showNotification('error', options.message || '', options.description || '', options.duration),
  warning: (options) => showNotification('warning', options.message || '', options.description || '', options.duration),
  info: (options) => showNotification('info', options.message || '', options.description || '', options.duration),
};
